/**
 * QR codes for the reverse verification deep links.
 *
 * The encoder runs in the page and reaches no network, so the token stays where
 * the create response put it.
 */

import qrcode from 'qrcode-generator';

// Error correction level. A higher level adds symbol versions, and the rendered
// size is fixed, so each module gets smaller.
const ERROR_CORRECTION = 'M';
// The module side in SVG user units. The tag is scalable, so this value sets
// the ratio between the symbol and its quiet zone, not the rendered size.
const CELL_SIZE = 4;
// The quiet zone the QR specification requires, which is four modules.
const MARGIN = CELL_SIZE * 4;

/**
 * An SVG tag for $text, dark modules on a white ground.
 *
 * The white ground belongs to the image rather than the page, because a camera
 * needs a light quiet zone in both themes.
 *
 * @param {string} text the deep link to encode
 * @returns {string} SVG markup, or an empty string when $text is empty
 */
export function createQrSvg(text) {
    const value = String(text || '');
    if (value === '') return '';

    // Type 0 picks the smallest symbol version that holds the data.
    const code = qrcode(0, ERROR_CORRECTION);
    code.addData(value);
    code.make();

    return code.createSvgTag({ cellSize: CELL_SIZE, margin: MARGIN, scalable: true });
}
